export class PathSnapshotsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PathSnapshotsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
